<template>

  <Dialog v-model:visible="visible"
    :style="{ width: '600px', maxHeight: '90wh' }"
    :modal="true"
    :contentStyle="{'overflow': 'visible'}"
    ref="dialog"
    @show="onShow"
    @hide="onHide"
    >
    <template #header>
      <h2>{{title}}</h2>
    </template>

    <div class="p-fluid p-grid">
      <div class="p-field p-col-12 p-md-3 p-input-filled">
        <label for="number">Продуктов номер</label>
        <InputText :tabindex="-1" id="code" type="text" v-model="productNumber" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-5 p-input-filled">
        <label for="name">Наименование</label>
        <InputText :tabindex="-1" id="name" type="text" v-model="productName" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="manufacturer">Търсене...</label>
        <AutoComplete v-model="data.product" :dropdown="true" field="name"
          :suggestions="products" @complete="searchProduct($event)" forceSelection
            placeholder="Въведете продукт" @itemSelect="onItemSelect">
            <template #item="props">
              {{props.item.number}} {{props.item.name}}
            </template>
        </AutoComplete>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="quantity">Количество</label>
        <InputNumber ref="quantity" id="quantity" v-model="data.quantity" mode="decimal"/>
      </div>
      <div class="p-field p-col-12 p-md-4">
        <label for="price">Ед. цена</label>
        <InputNumber ref="price" id="price" v-model="data.price" :minFractionDigits="2" :manFractionDigits="4" :format="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4 p-input-filled">
        <label for="net">Стойност нето</label>
        <InputText tabindex="-1" id="net" type="text" :value="$utils.currency(netto)"
          readonly="true" />
      </div>
      <!--
          v-on:keyup="$emit('update:modelValue', $event.target.value)"
          @keyup.enter.stop="onSave()"
      <div class="p-field p-col-12 p-md-4 p-input-filled">
        <label for="vatP">ДДС %</label>
        <InputText id="vatP" v-model="vatPerc" mode="decimal" :tabindex="-1" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4 p-input-filled">
        <label for="vat">ДДС</label>
        <InputText tabindex="-1" id="vat" type="text"
          :value="$utils.currency(vat)" :minFractionalDigits="2" :maxFractionalDigits="2" readonly="true"/>
      </div>
      <div class="p-field p-col-12 p-md-4 p-input-filled">
        <label for="gros">Стойност бруто</label>
        <InputText tabindex="-1" id="gros" type="text"
          :value="$utils.currency(total)" :minFractionalDigits="2" :maxFractionalDigits="2" readonly="true"/>
      </div>
      -->
    </div>

    <template #footer>
      <ButtonsApplyCancel @apply="onSave" @cancel="$refs.dialog.close()"/>
    </template>
  </Dialog>

</template>

<script>

export default {
  emits: {
    load: null,
    save: null
  },
  data() {
    return {
      visible: false,
      selected: {},
      tabIndex: 0,
      products: [],
      data: {
      }
    }
  },

  mounted() {
  },

  props: {
    title: String,
    hasVat : Boolean
  },

  methods: {
    searchProduct(event) {
      var ctx = this;
      this.$http.get('/product', {
        params: {
          query: event.query
        }
      }).then(res => ctx.products = res.data)
    },
    onShow() {
      var data = {};
      this.$emit('load', data);
      this.data = data;
      data.quantity = this.$utils.value(data.quantity);
      if (data.quantity == 0) {
        data.quantity = undefined;
      }
      data.price = this.$utils.value(data.price);
      if (data.price == 0) {
        data.price = undefined;
      }
    },
    onHide() {
      this.data = {}
    },
    onSave() {
      this.data.netto  = this.netto;
      this.data.vatPerc  = this.vatPerc;
      this.data.vat  = this.vat;
      this.data.total = this.total;
      this.$emit('save', this.data);
      this.$refs.dialog.close();
    },
    onItemSelect() {
    }
  },

  computed: {
    productNumber: function() {
      if (this.data.product) {
        return this.data.product.number;
      }
      return "";
    },
    productName: function() {
      if (this.data.product) {
        return this.data.product.name;
      }
      return "";
    },
    netto: function() {
      var netto = this.$utils.value(this.data.quantity) *  this.$utils.value(this.data.price);
      var discount = netto * this.$utils.value(this.data.vatPerc) / 100;
      return netto - discount;
    },
    vatPerc: function() {
      return this.hasVat ? this.$utils.value(this.data.vatPerc) : 0;
    },
    vat: function() {
      return this.netto * (this.vatPerc / 100);
    },
    total: function() {
      return this.netto + this.vat;
    }
  }
}
</script>

<style>

</style>
